import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import {labels} from '../../../util/utils';
import Modal from '../Modal/Modal';

export default function UnsavedChangesModal({
	show,
	title,
	confirmButtonTitle,
	closeTitle,
	onCancel,
	onConfirm,
	message,
	isAresView
}) {
	const warningIcon = (
		<svg className="icon-warning">
			<use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="#icon-warning" />
		</svg>
	);

	setTimeout(() => {
		/*put focus back on this modal if the user clicked on something else*/
		document.activeElement.blur();
	}, 10);

	return (
		<React.Fragment>
			{show && (
				<Modal
					autoFocus
					isAresView={isAresView}
					show={show}
					icon={warningIcon}
					modalsize={'x-small'}
					showButtons
					title={title}
					closeBtnTitle={confirmButtonTitle}
					confirmBtnTitle={closeTitle}
					isCancel
					showCloseButton={false}
					onOkClick={onCancel}
					onHide={onConfirm}
					modalContainerClass="UnsavedChangesModalContent"
					modalbodystyle="UnsavedChangesModalBody"
				>
					<StyledUnsavedChangesModalBody className="StyledUnsavedChangesModalBody">
						<span className="unsaved-changes">{message}</span>
					</StyledUnsavedChangesModalBody>
				</Modal>
			)}
		</React.Fragment>
	);
}

UnsavedChangesModal.propTypes = {
	show: PropTypes.bool,
	title: PropTypes.string,
	message: PropTypes.string,
	closeTitle: PropTypes.string,
	confirmButtonTitle: PropTypes.string,
	onCancel: PropTypes.func,
	onConfirm: PropTypes.func
};

UnsavedChangesModal.defaultProps = {
	title: labels.unsavedChangesTitle,
	message: labels.unsavedPageChangesMessage,
	closeTitle: labels.unsavedChangesStay,
	confirmButtonTitle: labels.unsavedChangesLeave
};

const StyledUnsavedChangesModalBody = styled.section`
	display: flex;
	align-items: center;
	padding: var(--px-20);
	.unsaved-changes {
		font-size: var(--px-14);
		font-weight: 300;
		width: 100%;
	}
`;
